import styled from 'styled-components';
import { EmptyStateBody, EmptyStateBox } from './EmptyStateStyles';

// eslint-disable-next-line
export const EmptyStatesContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  width: 100%;

  @media (max-width: 415px) {
    flex-flow: row wrap;
  }

  ${EmptyStateBox} {
    box-sizing: border-box;
    flex: 1;
    flex-direction: column;
    align-items: center;

    ${EmptyStateBody} {
      margin-bottom: 40px;
      text-align: center;
    }
    &:only-child {
      width: 50%;
      flex: 0 0 50%;
      position: relative;
      left: 25%;
      @media (max-width: 415px) {
        flex: 0 0 100%;
        width: 100%;
        left: 0%;
      }
    }
  }

  ${EmptyStateBox} + ${EmptyStateBox} {
    margin-left: 20px;
    @media (max-width: 415px) {
      margin-top: 20px;
      margin-left: 0;
    }
  }
`;

export const Heading1 = styled.h1`
  font-size: 24px;
  color: #444;
  font-weight: 600;
  margin: 0 0 4px 0;
`;

export const Heading2 = styled.h2`
  font-size: 16px;
  font-weight: 400;
  color: #444;
  line-height: 24px;
  margin: 0;
`;
